import { useState } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../api/client'
import { MailIcon } from '../components/Icons'

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(event: React.FormEvent) {
    event.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await api.forgotPassword(email.trim())
      setSent(true)
    } catch (failure) {
      // Only a transport problem or a throttle can land here: the API answers the same way
      // whether or not the address is registered.
      setError(failure instanceof Error ? failure.message : 'Something went wrong')
    } finally {
      setBusy(false)
    }
  }

  if (sent) {
    return (
      <div className="auth-wrap">
        <div className="auth-card">
          <h1>Check your email</h1>
          <p className="muted" style={{ marginTop: 8 }}>
            If <strong>{email.trim()}</strong> has an account, a reset link is on its way. It works
            once and expires in 30 minutes.
          </p>
          <div className="notice">
            Nothing arrived? Check the spam folder, then try again — the newest link is the only
            one that works.
          </div>
          <Link className="link" to="/sign-in" style={{ marginTop: 16, display: 'inline-block' }}>
            Back to sign in
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="auth-wrap">
      <form className="auth-card" onSubmit={submit}>
        <h1>Reset your password</h1>
        <p className="muted" style={{ marginTop: 8 }}>
          Enter the email you signed up with and we will send you a link to choose a new password.
        </p>

        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        {error && <div className="error">{error}</div>}

        <button className="primary" type="submit" disabled={busy}>
          <MailIcon />
          {busy ? 'Sending…' : 'Email me a link'}
        </button>

        <Link className="link" to="/sign-in" style={{ marginTop: 12, display: 'inline-block' }}>
          Back to sign in
        </Link>
      </form>
    </div>
  )
}
